import { render, staticRenderFns } from "./SettlementOrderList.vue?vue&type=template&id=5424970c&scoped=true&"
import script from "./SettlementOrderList.vue?vue&type=script&lang=js&"
export * from "./SettlementOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5424970c",
  null
  
)

export default component.exports